import { oneHub } from "@/types/oneHub";
// import categoryMock from './mock/category.json';
// import bookListMock from './mock/bookList.json';
// import bookDetail from './mock/bookDetail.json';
import { dealUrl } from "@/utils";


async function getOneHubPDFListEn(page: number | string) {
  try {
    const res: oneHub.IPdfResponse = await fetch(`${process.env.NEXT_PUBLIC_REQUEST_URL}/books1/pdf/page?langCode=en&size=500&page=${page}&sort=pdfUpdateMs,desc`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: process.env.NEXT_PUBLIC_AUTHORIZATION || '',
      },
      next: { revalidate: 86400, tags: ['onehub/pdf/'] },
    }).then(pdfRes => pdfRes.json());
    return res;
  } catch (error: Error | any) {
    console.log('🍿request/AudioStationFetch.ts:71/[error]:', error.message);
    return {
      code: 200,
      message: 'mock',
      data: {
        list: [],
        totalPage: 1,
      },
    } as any as oneHub.IPdfResponse;
  }
}

async function getCategory() {
  try {
    const res: oneHub.ICategoryResponse = await fetch(`${process.env.NEXT_PUBLIC_REQUEST_URL}/audio/foods/home?langCode=en`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      next: { revalidate: 86400, tags: ['onehub/home/category'] },
    }).then(cateRes => cateRes.json());
    return res.data.categoryList;
  } catch (error) {
    console.error('[-]', new Date() ,error);
    return [];
  }
}


async function getBookList(categoryIds: string[], page: number) {
  try {
    const listRes: oneHub.IBookListResponse = await fetch( `${process.env.NEXT_PUBLIC_REQUEST_URL}/audio/foods/category?langCode=en&categoryId=${categoryIds[0]}&subCategoryId=${categoryIds[1]}&size=40&page=${page - 1}&sort=aiGenerateTime,desc`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      next: { revalidate: 86400, tags: ['onehub/home/booklist'] },
    }).then(res => res.json());
    return {
      list: listRes.data.list,
      total: listRes.data.totalPage,
    }
  } catch (error) {
    console.error('[-]', new Date() ,error);
    return {
      list: [],
      total: 0,
    };
  }
}


async function getBookDetail(id: string) {
  const urlId = Buffer.from(dealUrl(id)).toString('base64');
  try {
    const bookRes: oneHub.IBookDetailResponse = await fetch( `${process.env.NEXT_PUBLIC_REQUEST_URL}/audio/foods/book-detail?langCode=en&urlId=${ urlId }`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      next: { revalidate: 2592000, tags: ['onehub/summary/book'] },
    }).then(res => res.json());
    return bookRes.data;
  } catch (error) {
    console.error('[-]', new Date() ,error);
  }
  return null;
}

export {
  getOneHubPDFListEn,
  getCategory,
  getBookList,
  getBookDetail,
}
